import { render, staticRenderFns } from "./Twofactor.vue?vue&type=template&id=38d608c2&scoped=true&"
import script from "./Twofactor.vue?vue&type=script&lang=js&"
export * from "./Twofactor.vue?vue&type=script&lang=js&"
import style0 from "./Twofactor.vue?vue&type=style&index=0&id=38d608c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d608c2",
  null
  
)

export default component.exports